<template>
    <div class="container">
        <div class="row justify-content-md-center main">
            <div class="col-12">
            <img src="../assets/cyberhaltestelle_monitor.png" class="main-logo">

                <h1 class="jumbotron-heading">Fahrplanmonitor</h1>
                <p class="lead">Der Fahrplanmonitor zeigt die nächsten Abfahrten von einer Haltestelle
                    in voller Bildschirmgröße an. Durch Drücken der F11-Taste kann die Website im Vollbildmodus angezeigt werden.
                    Durch die Eingabe deiner Haltestelle gelangst du zur Monitor-Seite. Der link in der Adresszeile ist eindeutig,
                    somit kann z. B. ein Startup-Script generiert werden.</p>
                    <!--<p><router-link to="page/tech">Informationen und Ideen zur
                    Anwendung.</router-link></p>-->
            <br >
            <router-link to="/page/einstellungen" tag="button" class="btn-lg btn-primary">Abfahrtsmonitor öffnen</router-link>
        </div>
        </div>
</div>
</template>

<script>
export default {
  name: 'HomeElement'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.main-logo {
    display: block;
    margin: auto;
    height: 16rem;
}

.list-group {
    max-height: 200px;
    margin:auto;
    overflow: auto;
    position: absolute;
    z-index: 500;
}

.list-group li {
    display: block;
}

.home button{
    width: 100%;
    margin-bottom: .5em;
}

</style>
